import z from 'zod';
import { IAIARequest } from './interface';
import { getSchema as getAiaSchema } from './aiaSchema';
import { getSchema as getTestingPlanSchema } from '../common/testingPlanSchema';
import { MetaSchema } from '../request';
import { IFieldErrors, ValidationError } from '../../validation';
import { Draft } from 'src/types/common';

const BaseAiaRequest = z.object({
  categoryId: z.string().min(1),
  userId: z.string().min(1),
  appliedLevel: z.enum(['1', '2']),
  meta: MetaSchema
});

/**
 * Returns the Zod Validation Schema for the update request.  This is a factory
 * method due to the fact that it contains conditional validations and the schema
 * needs to be built based off certain selections
 */
const getSchema = (update: Draft<IAIARequest>) => {
  const aiaSchema = getAiaSchema(update.appliedLevel || '1', update.data?.aia || {});
  const testingPlanSchema = getTestingPlanSchema(update.data?.testingPlan || {});

  if (update.appliedLevel === '1') {
    return BaseAiaRequest.extend({
      data: z.object({
        aia: aiaSchema
      })
    });
  } else {
    return BaseAiaRequest.extend({
      data: z.object({
        aia: aiaSchema,
        testingPlan: testingPlanSchema
      })
    });
  }
};

export const validate = (update: Draft<IAIARequest>): IAIARequest => {
  const schema = getSchema(update);
  try {
    // Ensure there are changes from the original record
    return schema.parse(update);
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};